
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/event/history/[...slug]",
      function () {
        return require("private-next-pages/event/history/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/event/history/[...slug]"])
      });
    }
  